import styled from 'styled-components'
import TypographyPro from 'themes/TypographyPro'
import { resetButton, respondAbove } from 'styles/mixins'
import ImageComponent from 'themes/ImageComponent'

export const StyledOrderTypeButton = styled.button`
	${resetButton}
	display: flex;

	height: 12.5rem;
	justify-content: space-between;

	border-radius: var(--borderRadiusM);
	background: var(--bgLight);
	box-shadow: var(--shadowSmall);

	align-items: center;
	padding: 20px;
    gap: 1.25rem;
`

export const StyledOrderTypeTitle = styled(TypographyPro)`
	color: var(--strokeMenuTitle);
	flex: 1;
	text-align: center;
`

export const StyledOrderTypeImageContainer = styled.div`
	width: 8.25rem;
	height: 8.25rem;

	${respondAbove.lg`
		width: 10rem;
		height: 10rem;
	`}
`

export const StyledOrderTypeImage = styled(ImageComponent)`
	object-fit: contain;
	border-radius: var(--borderRadiusM);
	width: 8.25rem;
	height: 8.25rem;

	${respondAbove.lg`
		width: 10rem;
		height: 10rem;
	`}
`